import useQueryURL from "../../../../../common/hooks/useQueryURL";
import ModalDrawer from "../../../../../common/components/organisme/ModalDrawer/ModalDrawer";
import NewStationFormPresenter from "../NewStationForm/NewStationFormPresenter";

/**
 *
 */
export default function NewStationModal({
  modalId,
  organizationId,
  stationIdToUpdate,
  isUpdate: isUpdateRaw,

}: {
  modalId?: string;
  organizationId?: string;
  stationIdToUpdate?: string;
  isUpdate?: boolean;
}) {
  const isUpdate = isUpdateRaw   || (!!stationIdToUpdate);
  const defaultId = !isUpdate ? "modal_add_station" : "modal_update_station";
  const { removeQueryValue } = useQueryURL();
  const MODAL_ID_PARAMS = modalId || defaultId;
  const onSuccessfulSubmit = () => {
    removeQueryValue([MODAL_ID_PARAMS]);
  };

  

  return (
    <ModalDrawer title={isUpdate ? "Modifier" : "Nouvelle Station"} urlParamName={MODAL_ID_PARAMS}>
      <NewStationFormPresenter
        organizationId={organizationId}
        onSuccess={onSuccessfulSubmit}
        idStationToUpdate={stationIdToUpdate}
        isUpdate={isUpdate}
      />
    </ModalDrawer>
  );
}
